import React from "react";
import { Link } from "react-router-dom";

import "../styles/drawer.scss";
import { ImCross, ImHome } from "react-icons/im";
import { GrContactInfo } from "react-icons/gr";
import { MdRestaurantMenu } from "react-icons/md";
import CustomLink from "./custom-link";

const Drawer = (props) => {
  return (
    <nav
      className={
        props.showDrawer ? "drawer-container open" : "drawer-container"
      }
    >
      <div className="drawer__top-section">
        <div className="drawer__logo-container">
          <h3 className="drawer__logo-title">
            Deccan <span>Express</span>
          </h3>
          <img
            src={require("../assets/images/res-logo.png")}
            alt="logo"
            className="drawer__logo"
          />
        </div>
        <span
          onClick={() => {
            props.setDrawer(false);
          }}
          className="drawer__close-icon"
        >
          <ImCross />
        </span>
      </div>
      <div className="drawer__links-section">
        <ul>
          <CustomLink to="/" icon={<ImHome />} setDrawer={props.setDrawer}>
            Home
          </CustomLink>
          <CustomLink
            to="/menu"
            icon={<MdRestaurantMenu />}
            setDrawer={props.setDrawer}
          >
            Menu
          </CustomLink>
          <CustomLink
            to="/contact-us"
            icon={<GrContactInfo />}
            setDrawer={props.setDrawer}
          >
            Contact Us
          </CustomLink>
        </ul>
      </div>
    </nav>
  );
};

export default Drawer;
